import { render, staticRenderFns } from "./globalOtpVerify.vue?vue&type=template&id=25b794b1&scoped=true&"
import script from "./globalOtpVerify.vue?vue&type=script&lang=js&"
export * from "./globalOtpVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b794b1",
  null
  
)

export default component.exports